import React from 'react';
import type { Tenant } from './types';

interface TenantLogoProps {
  tenant: Tenant | null | undefined;
  /** Rendered height in px — the mark keeps its own aspect ratio. */
  size?: number;
  className?: string;
  /** Defaults to empty: every call site shows the studio name alongside, so
   *  announcing it twice only adds noise for a screen reader. */
  alt?: string;
}

/**
 * The studio's own logo, when they have uploaded one (Branding.logo).
 *
 * Tenants are white-labelled: a member landing on their studio's portal
 * should see that studio's mark, not ours. Renders nothing when no logo is
 * set, so every call site must still read well without it.
 */
export const TenantLogo: React.FC<TenantLogoProps> = ({
  tenant, size = 64, className, alt = '',
}) => {
  const src = tenant?.branding?.logo;
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt}
      style={{ height: size, width: 'auto', objectFit: 'contain' }}
      className={className}
    />
  );
};
